import React, { useState } from "react";
import { Link } from "react-router-dom";
import { blogPosts, siteConfig } from "../data/mockData";
import { BlogCard, BlogFeaturedPost, BlogArticleView } from "../components/blog/BlogComponents";

const categories = ["All", "Education", "Small Business", "Self-Employed", "Updates", "Tips"];

const BlogPage = () => {
  const [activeCategory, setActiveCategory] = useState("All");
  const [selectedPost, setSelectedPost] = useState(null);

  const filteredPosts =
    activeCategory === "All"
      ? blogPosts
      : blogPosts.filter((post) => post.category === activeCategory);

  if (selectedPost) {
    return <BlogArticleView post={selectedPost} onBack={() => setSelectedPost(null)} />;
  }

  return (
    <>
      {/* Hero */}
      <section className="pt-28 pb-12 bg-gradient-to-b from-[#F1F8F2] to-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <span className="text-sm font-semibold text-[#3A7D44] uppercase tracking-wider">
            Blog
          </span>
          <h1
            className="text-4xl sm:text-5xl font-bold text-[#1B2A1B] mt-3 mb-6"
            style={{ fontFamily: "'DM Sans', sans-serif" }}
          >
            Insurance Insights & Guides
          </h1>
          <p className="text-lg text-[#5A6B5A] leading-relaxed max-w-2xl mx-auto">
            Helpful articles to make health insurance less confusing. Written
            by Kimberly Hess for real people.
          </p>
        </div>
      </section>

      {/* Category Filter */}
      <section className="py-6 bg-white border-b border-gray-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-wrap gap-2 justify-center">
            {categories.map((cat) => (
              <button
                key={cat}
                onClick={() => setActiveCategory(cat)}
                className={`px-4 py-2 rounded-full text-sm font-medium transition-colors duration-200 ${
                  activeCategory === cat
                    ? "bg-[#3A7D44] text-white"
                    : "bg-[#F1F8F2] text-[#5A6B5A] hover:bg-[#E8F5E9] hover:text-[#3A7D44]"
                }`}
              >
                {cat}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Blog Grid */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {filteredPosts.length > 0 && (
            <BlogFeaturedPost post={filteredPosts[0]} onClick={setSelectedPost} />
          )}

          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-8">
            {filteredPosts.slice(1).map((post) => (
              <BlogCard key={post.id} post={post} onClick={setSelectedPost} />
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-16 bg-[#F1F8F2]">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2
            className="text-2xl font-bold text-[#1B2A1B] mb-4"
            style={{ fontFamily: "'DM Sans', sans-serif" }}
          >
            Still Have Questions?
          </h2>
          <p className="text-[#5A6B5A] mb-6">
            Reading is great, but sometimes you just need to talk to a real
            person. I'm happy to help.
          </p>
          <a
            href={siteConfig.calendlyUrl}
            
            
            className="inline-flex items-center gap-2 px-6 py-3 text-sm font-semibold text-white bg-[#3A7D44] rounded-lg hover:bg-[#2D5A35] transition-colors"
          >
            Get in Touch
          </a>
        </div>
      </section>
    </>
  );
};

export default BlogPage;
